import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import Utils from "../../../../utils";
import Pagination from "react-js-pagination";
import { getGroupList } from "../../../../services/UserService";
import ModifyGroup from "./ModifyGroup";
import DeleteGroup from "./DeleteGroup";

const lengths = Utils.tableShowLengths();

function SettingUserGroup(props) {

  const [loading, setLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [totalGroup, setTotalGroup] = useState(0);
  const [userList, setUserList] = useState([]);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [isCall, setIsCall] = useState(false);
  const [listProcess, setListProcess] = useState('loading...');

  const [isGroupTab, setIsGroupTab] = useState(true);

  const groupModalRef = useRef(null);

  const [groupData, setGroupData] = useState({
    id: 0,
    name: '',
    users: []
  });

  useEffect(function () {

    setGroupList([]);
    setListProcess('loading...');
    let obj = {
      limit: limit,
      search: search,
      page: page
    };

    getGroupList(obj)
      .then(response => {
        setUserList(response.data.userList);
        setTotalGroup(parseInt(response.data.count));
        setGroupList(response.data.data);
        if (response.data.data.length === 0) {
          setListProcess('No data available.');
        }
      })
      .catch(err => {
        setListProcess('No data available.');
      });

  }, [limit, page, search, isCall]);

  useEffect(function () {
    let loginData = Utils.loginUserData();
    if (Object.keys(loginData).length > 0) {
      if (loginData.role_id > 3) {
        setIsGroupTab(false);
      }
    }
  }, []);

  const handleEditGroup = (e, data) => {
    e.preventDefault();

    setGroupData({
      id: data.id,
      name: data.name,
      users: data.users
    });

    groupModalRef?.current.click();
  };

  const handleDeleteGroup = (e, data) => {
    e.preventDefault();

    setGroupData({
      id: data.id,
      name: data.name,
      users: data.users
    });
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="active show" id="user" role="tabpanel" aria-labelledby="user-tab">
        <div className="breadcrumbs">
          <ul>
            <li>Settings /</li>
            <li>Users</li>
          </ul>
        </div>
        <div className="nav nav-tabs setting-tabs" id="navtab" role="tablist">
          <NavLink to={"/settings/users"} className="nav-link setting-link" id="users" type="button"
            role="tab" end>Users</NavLink>
          {isGroupTab === true && (
            <NavLink to={"/settings/users/group"} className="nav-link active setting-link" id="group-tab" type="button"
              role="tab">Group</NavLink>
          )}
        </div>
        <div className="setting-panel" id="navContent">
          <div
          className="setting-tab-section active" 
            id="group"
            role="tabpanel"
          >
            {/* HEADER */}
            <div className="setting-table-header">
              <div className="setting-search-box">
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search groups..."
                  className="setting-search-input"
                />
                <span className="setting-search-icon">
                  <i className="bi bi-search"></i>
                </span>
              </div>

              <div className="setting-action-right">
                <button
                  className="setting-btn-primary"
                  data-bs-toggle="offcanvas"
                  ref={groupModalRef}
                  data-bs-target="#modifyGroup"
                >
                  + Create Group
                </button>
              </div>
            </div>

            {/* TABLE */}
            <div className="setting-table-wrapper">
              <table className="setting-table">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Group Name</th>
                    <th>Users</th>
                    <th></th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {groupList.map((item, index) => (
                    <tr key={index}>
                      <td>{item.created_at}</td>
                      <td>{item.name}</td>

                      <td>
                        <span className="setting-badge">{item.total_user}</span>
                      </td>

                      <td></td>

                      <td>
                        <i
                          className="bi bi-pencil-fill setting-icon-edit"
                          onClick={(e) => handleEditGroup(e, item)}
                        ></i>

                        <i
                          className="bi bi-trash setting-icon-delete"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteGroupModal"
                          onClick={(e) => handleDeleteGroup(e, item)}
                        ></i>
                      </td>
                    </tr>
                  ))}

                  {groupList.length === 0 && (
                    <tr>
                      <td colSpan={5} className="setting-empty-row">
                        {listProcess}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINATION */}
            {totalGroup > 10 && (
              <div className="setting-table-footer">

                <div className="setting-footer-left">
                  <span>Show</span>

                  <select
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                    className="setting-select-small"
                  >
                    {lengths.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="setting-footer-pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={limit}
                    totalItemsCount={totalGroup}
                    pageRangeDisplayed={5}
                    onChange={(e) => setPage(e)}
                  />
                </div>

              </div>
            )}
          </div>
        </div>

      </div>

      <ModifyGroup userList={userList} groupData={groupData} setGroupData={setGroupData} isCall={isCall}
        setIsCall={setIsCall} setLoading={setLoading} />

      <DeleteGroup groupData={groupData} setGroupData={setGroupData} isCall={isCall} setIsCall={setIsCall}
        setLoading={setLoading} />
    </>
  );
}

export default SettingUserGroup;
